<template>
  <div class="registration-window" id="registration-window">
    <div class="registration-window-fl">
      <div class="registration-window-wrap">
        <router-link :to="{ name: 'home' }" class="registration-window-close"></router-link>

        <div class="registration-window-title">Регистрация</div>

        <div class="registration-window-bonus">
          <a href="bonuses" class="registration-window-bonus-info"></a>
          <div class="registration-window-bonus-title">Приветственный<br />пакет бонусов</div>
          <div class="registration-window-bonus-summ">250%</div>
          <div class="registration-window-bonus-adv">+ 30 фриспинов</div>
          <img :src="require('@/assets/images/levels-banner1.webp')" class="registration-window-bonus-image" alt="" />
        </div>

        <div class="registration-window-reg">
          <div class="tt-tabs tabs-rwr">
            <div class="index-tabs">
              <span @click="this.regmethod = 'phone'" :class="this.regmethod === 'phone' ? 'active-ttab' : ''"
                >· По телефону ·</span
              >
              <span @click="this.regmethod = 'email'" :class="this.regmethod === 'email' ? 'active-ttab' : ''"
                >· По почте ·</span
              >
            </div>
            <div class="index-panel">
              <div v-if="this.regmethod === 'email'" class="tt-panel">
                <form @submit.prevent.stop="this.onSubmit">
                  <div class="rwr-line">
                    <input type="text" name="" class="rwr-input" placeholder="Ваша почта" v-model="email" required />
                    <span class="error" v-if="emailErrorMessage">{{ emailErrorMessage }}</span>
                  </div>
                  <div class="rwr-line">
                    <input type="text" name="" class="rwr-input" placeholder="Логин" v-model="username" required />
                  </div>
                  <div class="rwr-line">
                    <input
                      :type="passwordFieldType"
                      name=""
                      class="rwr-input"
                      placeholder="Пароль"
                      v-model="password"
                      required
                    />
                    <i class="icp" @click="switchVisibility"></i>
                    <span class="error" v-if="passwordErrorMessage">{{ passwordErrorMessage }}</span>
                  </div>
                  <div class="form-line-promo">
                    <div class="form-line-promo-l">
                      <input
                        type="text"
                        class="rwr-input"
                        name=""
                        placeholder="Промокод (если есть)"
                        v-model="promocode"
                      />
                    </div>

                    <currency :setValue="data => (this.currency = data)" :value="this.currency" />
                  </div>
                  <button
                    type="submit"
                    class="registration-btn"
                    :disabled="!email || !password || !username || passwordErrorMessage || emailErrorMessage"
                  >
                    {{ this.isLoading ? 'Подождите' : 'Зарегистрироваться' }}
                  </button>
                </form>
              </div>
              <div v-if="this.regmethod === 'phone'" class="tt-panel">
                <form @submit.prevent.stop="this.onSubmit">
                  <div class="form-line-promo">
                    <phone :setValue="data => (this.phone = data)" :value="this.phone" />
                  </div>

                  <div class="form-line-promo">
                    <div class="form-line-promo-l">
                      <input
                        type="text"
                        class="rwr-input"
                        name=""
                        placeholder="Промокод (если есть)"
                        v-model="promocode"
                      />
                    </div>

                    <currency :setValue="data => (this.currency = data)" :value="this.currency" />
                  </div>
                  <button type="submit" class="registration-btn" :disabled="!phone">
                    {{ this.isLoading ? 'Подождите' : 'Зарегистрироваться' }}
                  </button>
                </form>
              </div>

              <socials />

              <div class="reg-label rwr-reg-label">
                <span>Уже зарегистрированы?</span>
                <router-link :to="{ name: 'login' }" class="only-open-login">Войти</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OPEN_GLOBAL_POPUP, REGISTER } from '@/store/actions.type'
import PlayLine from '@/components/PlayLine'
import { useI18n } from 'vue-i18n'
import Socials from '@/components/Socials'
import Currency from '@/components/Fields/Currency'
import Phone from '@/components/Fields/Phone'
import { toast } from 'vue3-toastify'
import { emailValidation, passwordValidation } from '@/utils'
import { getSavedRefId } from '@/common/referal'

export default {
  name: 'Register',
  components: { Currency, Phone, Socials, PlayLine },
  data() {
    return {
      username: null,
      email: null,
      login: null,
      password: null,
      phone: null,
      promocode: '',
      currency: 'RUB',
      regmethod: 'phone',
      isLoading: false,
      passwordFieldType: 'password',
      passwordErrorMessage: null,
      emailErrorMessage: null,
    }
  },
  setup() {
    const { t, locale } = useI18n()
    return { t, locale }
  },
  watch: {
    password: function () {
      this.passwordErrorMessage = passwordValidation(this.username, this.password)
    },
    username: function () {
      if (this.password) {
        this.passwordErrorMessage = passwordValidation(this.username, this.password)
      }
    },
    email: function () {
      if (this.email) {
        this.emailErrorMessage = emailValidation(this.email)
      }
    },
  },
  methods: {
    onSubmit() {
      if (!this.isLoading) {
        this.isLoading = true

        this.$store
          .dispatch(REGISTER, {
            registration_type: this.regmethod,
            username: this.username,
            email: this.email,
            password: this.password,
            currency: this.currency,
            lang: this.locale,
            phone: this.phone,
            reg_promocode: this.promocode,
            ref_id: getSavedRefId(),
          })
          .then(res => {
            this.isLoading = false
            this.$router.push({ name: 'home', hash: '#reg-success' + (this.regmethod === 'phone' ? '-phone' : '') })
          })
          .catch(res => {
            this.isLoading = false
            toast.error(res?.data?.err)
          })
      }
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
  },
  mounted() {
    this.$store.dispatch(OPEN_GLOBAL_POPUP, true)
  },
  unmounted() {
    this.$store.dispatch(OPEN_GLOBAL_POPUP, false)
  },
}
</script>

<style scoped>
.registration-btn {
  border: none;
  cursor: pointer;
  margin: 10px 0;
  padding: 0 20px;
  width: 100%;
}
.registration-btn:disabled {
  color: #333;
}
</style>
